import React from 'react'
import { fetchDocuments } from '../../../service/documentsService'
import PropTypes from 'prop-types'
import { setItem as setItemInLocalStorage, getItem as getItemInLocalStorage } from '../../../localStorage/localStorageManager'
import { Table, Alert, FormText } from 'reactstrap'
import FileLink from '../fileLink'
import moment from 'moment'
import { downloadDocument } from '../../../service/documentsService'
import { openFileInNewTab } from '../../../util/documentManager'
import Loading from '../loading'
import browser from 'browser-detect'

export default class FilesForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = { loading: false, alertBrowser: false }
    }

    componentDidMount() {
        this.alertIfIOS() // Alerte l'utilisateur qu'il faut qu'il utilise Safari 13 sur ios
        this.setState({ loading: true })
        this.props.filesToState(getItemInLocalStorage('FILES_LIST')) // affichage hors ligne de base
        fetchDocuments() // Axios
            .then(({ data }) => {
                this.props.filesToState(data) // Redux
                setItemInLocalStorage('FILES_LIST', data) // Local storage
            })
            .catch(err => {
                // Impossible de récupérer les fichiers,
                // On affiche la liste des fichiers enregistrés en cache (local storage)
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    // Detect if the user is browsing on iOS with something else than Safari
    alertIfIOS = () => {
        const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        const browserVersion = browser().versionNumber
        if (iOS && browserVersion < 13) {  // iOS avec version < 12 (safari ou autre)
            this.setState({ alertBrowser: true })
        }
    }

    downloadFile = (e, file) => {
        e.preventDefault()
        // Should download here
        downloadDocument(file.Url)
            .then(({ data }) => {
                openFileInNewTab(data, file.Name)
            })
            .catch(err => {
                console.log(err)
            })
    }

    filesList = () => {
        try {
            return (
                <React.Fragment>
                    {this.props.filesList.map(file => {
                        return (
                            <tr className="table-row" key={file.Id} onClick={(e) => this.downloadFile(e, file)}>
                                <td><FileLink file={file} /></td>
                                <td>{moment(file.TimeCreated).format('DD-MM-YYYY')}</td>
                            </tr>
                        )
                    })}
                    {this.state.loading && <tr className="file-loading">
                        <td>
                            <Loading />
                        </td>
                        <td></td>
                    </tr>}
                </React.Fragment>

            )
        } catch (err) {
            return <React.Fragment />
        }
    }

    render() {
        return (
            <div>
                {
                    this.props.filesList && this.props.filesList.length > 0 ?
                        <React.Fragment>
                            <Table responsive striped>
                                <thead>
                                    <tr>
                                        <th>File</th>
                                        <th>Created</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.filesList()}
                                </tbody>
                            </Table>
                            <FormText>
                                The file download should only work for these platforms/browsers : Computer (Chrome, Firefox, Opera, Edge, Internet Explorer), Android (Chrome), iOS (Safari >= 13).
                            </FormText>
                            {this.state.alertBrowser && <Alert className="text-center" color="danger">On iOS, you should use Safari (13 or higher) to download the file !</Alert>}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {this.state.loading ? <div className="col-1 offset-8 file-loading"><Loading /></div>
                                :
                                <React.Fragment>
                                    <h4 className="text-center">No files found</h4>
                                    <p className="text-center">Check out if you are <b>online</b></p>
                                </React.Fragment>
                            }
                        </React.Fragment>
                }
            </div >

        )
    }
}

FilesForm.propTypes = {
    filesToState: PropTypes.func,
    filesList: PropTypes.array
}